import { useCallback, useState } from 'react'

export function useTour(key) {
  const storageKey = `kartquiz_tour_${key}_done`
  const [done, setDone] = useState(() => localStorage.getItem(storageKey) === '1')

  const markDone = useCallback(() => {
    localStorage.setItem(storageKey, '1')
    setDone(true)
  }, [storageKey])

  const resetTour = useCallback(() => {
    localStorage.removeItem(storageKey)
    setDone(false)
  }, [storageKey])

  return { shouldShow: !done, markDone, resetTour }
}
